module.exports = __webpack_public_path__ + "img/mew-custom-token.547fbec8.png";